<div class="Stores ui-g-12">

  <div class="ui-g" *ngIf="data != null">
    <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
      <app-infobox [pointData]="indicator.pointData" [t]="indicator.t" [options]="indicator.options"></app-infobox>
    </div>
  </div>

  <div class="campaigncharts" *ngIf="data != null">
    <div class="ui-g">
      <h2>{{ 'store.revenue' | translate }}</h2>
    </div>

    <div class="ui-g">
      <div class="chart-container" style="width: 100% !important;">
        <chart [options]="trendChart.options" (load)="setChartInstance(trendChart, $event.context)" style="display: block;"></chart>
      </div>
    </div>
  </div>

  <p-dialog header="{{ 'common.error' | translate }}" [(visible)]="storeError" [width]="300" [modal]="true" [draggable]="false" [resizable]="false">
    <p>{{ selectOneError }}</p>
    <div class="ui-dialog-footer">
      <button pButton type="button" class="slim red-button" (click)="toogleErrorStoreDialog()" label="Ok"></button>
    </div>
  </p-dialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/store/analysis/analysis-single-store-trend/analysis-single-store-trend.component.html